document.addEventListener('DOMContentLoaded', function () {

    const productsCarousel = document.querySelectorAll('.section-products-carousel .products-carousel');
    productsCarousel.forEach((element) => {
        if (element) {
            const pagination = element.closest('.section-products-carousel').querySelector('.slider-pagination');
            const nextButton = element.closest('.section-products-carousel').querySelector('.slider-button-next');
            const prevButton = element.closest('.section-products-carousel').querySelector('.slider-button-prev');

            const swiper = new Swiper(element, {
                spaceBetween: 16,
                slidesPerView: 1,
                freeMode: true,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                breakpoints: {
                    800: {
                        spaceBetween: 32,
                        slidesPerGroup: 3,
                        slidesPerView: 2,
                        grabCursor: true,
                        pagination: {
                            el: pagination,
                            clickable: true,
                        }
                    },
                    1200: {
                        spaceBetween: 32,
                        slidesPerView: 3
                    }
                }
            });
        }
    });
    
});